<template>
  <div></div>
</template>

<script>
export default {
  async beforeMount() {
    const page = this.$route.params.page
    const action = this.$route.params.action
    const userId = this.$route.params.userId
    await this.$router.push({name: page, params: {action, userId}});
  },
}
</script>

<style>

</style>
